<div class="min-h-screen w-full flex items-center justify-center bg-gray-50">
    <app-card class="w-full max-w-md mx-4">
        <app-card-content class="pt-6">

            <div class="flex mb-4 gap-2 items-center">
                <!-- Alert Icon -->
                <svg class="h-8 w-8 text-red-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>

                <h1 class="text-2xl font-bold text-gray-900">
                    404 Page Not Found
                </h1>
            </div>

            <p class="mt-4 text-sm text-gray-600">
                Did you forget to add the page to the router?
            </p>

        </app-card-content>
    </app-card>
</div>